<ng-container *ngIf="!!value">
  <mat-chip-list class="d-block mb-4">
    <mat-chip style="background-color: #F2F5F8 !important;"
              class="d-flex flex-nowrap align-items-center w-100 h-auto px-3 py-2 mb-2 rounded lh-lg"
              disableRipple="true">
      <span class="w-50 fw-medium">
        <ng-container i18n="@@global.label.attributeKey">Attribute Key</ng-container>
      </span>
      <span class="w-50 fw-medium">
        <ng-container i18n="@@global.label.attributeValue">Attribute Value</ng-container>
      </span>
      <button class="w-auto h-auto p-1 lh-1 invisible"
              type="button"
              mat-icon-button
              matChipRemove>
        <mat-icon class="lh-1">close</mat-icon>
      </button>
    </mat-chip>
    <mat-chip style="background-color: #F2F5F8 !important;"
              class="d-flex flex-nowrap align-items-center w-100 h-auto px-3 py-2 mb-2 rounded lh-lg"
              *ngFor="let entry of value | keyvalue; trackBy: trackKey"
              disableRipple="true"
              (removed)="removeAttribute(entry.key)">
      <span class="w-50">{{entry.key}}</span>
      <span class="w-50">{{entry.value}}</span>
      <span class="flex-fill"></span>
      <button class="w-auto h-auto p-1 lh-1"
              type="button"
              mat-icon-button
              matChipRemove>
        <mat-icon class="lh-1">close</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-list>
</ng-container>

<div id="id"
     (focusin)="onFocusIn($event)"
     (focusout)="onFocusOut($event)">
  <div class="d-flex flex-nowrap align-items-start">
    <div>
      <div class="d-flex flex-column-reverse flex-nowrap mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-select name="authority" required="true" [(value)]="selectedKey">
            <mat-option *ngFor="let key of activeOptions();" [value]="key">
              {{key}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-label>
          <ng-container i18n="@@global.label.attributeKey">Attribute Key</ng-container>
        </mat-label>
      </div>
    </div>
    <div class="ml-3">
      <div class="d-flex flex-column-reverse flex-nowrap mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <input type="text"
                 name="attributeValue"
                 matInput
                 [(ngModel)]="enteredValue">
        </mat-form-field>
        <mat-label>
          <ng-container i18n="@@global.label.attributeValue">Attribute Value</ng-container>
        </mat-label>
      </div>
    </div>
    <div>
      <button class="mt-4"
              type="button"
              mat-icon-button
              color="primary"
              [disabled]="!enteredValue?.trim()"
              (click)="addAttribute()">
        <mat-icon fontSet="fill">add_circle</mat-icon>
      </button>
    </div>
  </div>
</div>